var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeliveryProgressCompleted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0070CC",
    d: "M6 1C3.2386 1 1 3.2386 1 6s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5m0 2.5c1.3807 0 2.5 1.1193 2.5 2.5S7.3807 8.5 6 8.5 3.5 7.3807 3.5 6 4.6193 3.5 6 3.5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeliveryProgressCompleted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delivery-progress-completed.f4e1cda4da8c977398c65b4bccd13db3.svg";